/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import {
  defaultForgotPasswordForm,
  defaultLoginForm,
  defaultRegisterForm,
  initialState,
} from "./initialState";
import { IUserDataInterface } from "../types";
import { IAddCartData } from "../../Products/Cart/types";

export const useClinicSlice = createSlice({
  name: "authState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setIsToken: (state, action: PayloadAction<string | null>) => {
      state.isToken = action.payload;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    updateForgotPasswordFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `forgotPasswordForm.${action.payload.key}`, action.payload.value);
    },
    updateRegisterFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `registerForm.${action.payload.key}`, action.payload.value);
    },

    doRetailLogin: (
      state,
      action: PayloadAction<{ callback: (token: string) => void }>
    ) => {},
    doRetailRegister: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},

    // ---------------------------------------

    clearRegisterFrom: (state) => {
      state.registerForm = { ...defaultRegisterForm };
    },
    clearFrom: (state) => {
      state.form = { ...defaultLoginForm };
    },
    clearForgotPasswordForm: (state) => {
      state.forgotPasswordForm = { ...defaultForgotPasswordForm };
    },
    doLogin: (
      state,
      action: PayloadAction<{ callback: (token: string) => void, cartData?:IAddCartData[] }>
    ) => {},
    doRegister: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doForgotPassword: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doLogOut: (state) => {
      localStorage.removeItem("token");
    },
    

    setIsLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },

    doGetProfile: (
      state,
      action: PayloadAction<{
        token: string;
        callback: () => void;
      }>
    ) => {},

    doGetUserProfile: (state) => {},
    setProfileData: (state, action: PayloadAction<IUserDataInterface>) => {
      state.userData = action.payload;
    },
    toggleShowPassword: (state) => {
      state.togglePassword = !state.togglePassword;
    },
    toggleConfirmPassword: (state) => {
      state.toggleConfirmPassword = !state.toggleConfirmPassword;
    },
   
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
